import { TFunction } from 'i18next';
import { SelectItem } from '../../form-certificate-type-select/types';

export const getAccreditationTypeOptions = (t: TFunction<'web-common'>): SelectItem[] => [
  { value: 'receipt', label: t('upload-certificate-screen.accreditation-type.receipt') },
  { value: 'full', label: t('upload-certificate-screen.accreditation-type.full') },
];
